@if ((_users?.length === 0 || _locations?.length === 0) && searchTermIsPresent) {
<div class="no-locations-message">
    {{localize(langSection.LocationUserPage, langText.NoLocationsMatch)}}
</div>
}
<div #locationUserContainer [ngStyle]="(_users?.length > 0 && _locations?.length > 0) ? '' : {'display': 'none'}" class="location-user-grid">
    <div #userHeaderContainer class="user-header-table">
        <table #userHeaderTable style="left:{{scrollLeft}}px;" aria-label="User Header Table">
            <thead>
                <tr>
                    <th id="blank-cell" class="location"></th>
                    @for (user of _users; track user; let iUser = $index) {
<th scope="col">
                        <user-header [user]="user"></user-header>
                    </th>
}
                </tr>
            </thead>
        </table>
    </div>
    <table #locationUserTable style="left:{{scrollLeftView}}px;" aria-label="Location User Table">
        <thead>
            <tr>
                @if (!_users.length) {
<td></td>
}
                @if (_users.length) {
<th id="blank-cell"></th>
}
                @for (user of userView; track user; let iUser = $index) {
<th scope="col">
                    <user-header [user]="user"></user-header>
                </th>
}
            </tr>
        </thead>
        <tbody>
            @for (location of _locations; track location; let iLocation = $index) {
<tr class="location-row">
                <th scope="row">
                    <location-header [location]="location"></location-header>
                </th>
                @for (user of userView; track user; let iUser = $index) {
<td class="user user-info">
                    @if (iLocation >= firstVisibleLocationIndex && iLocation <= lastVisibleLocationIndex) {
<user-access 
                        
                        [location]="location" 
                        [user]="user"
                        [cellErrors]="cellErrors"
                        (error)="handleCellError($event)" 
                        (userRoleChanged)="refreshUserRole($event)"
                        class="w-100 h-100"></user-access>
}
                </td>
}
            </tr>
}
        </tbody>
    </table>
    <div class="scrollbar" (scroll)="onUserScroll($event)"><div style="height:1px;width:{{scrollWidth}}px"></div></div>
</div>